<template>
  <span>
    <button
      v-if="
        isExpired(obj.subscription.valid_until) ||
        (plans.length > 0 &&
          plans[plans.length - 1].code != obj.subscription.subscription_plan.code) ||
          obj.subscription.subscription_plan.code.includes('business-')
      "
      @click="showRenewModal(obj.id)"
      type="button"
      class="btn btn-primary"
    >
      <span class="fa fa-shopping-cart"></span>
      {{ getButtonText(obj.subscription.subscription_plan.code) }}
    </button>
    <div
      class="modal fade"
      :id="'paymentModalRenew-' + obj.id"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              @click="hideRenewModal()"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="pficon pficon-close"></span>
            </button>
            <h4 class="modal-title" id="myModalLabel">
              {{ onUpgrade ? $t("payment.upgrade") : $t("payment.renew") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="card-pf-view">
              <div>
                <div class="card-pf-top-element">
                  <span
                    :class="[
                      'fa',
                      onUpgrade ? 'fa-arrow-up' : 'fa-refresh',
                      'card-pf-icon-circle',
                      'adjust-icon-size',
                    ]"
                  ></span>
                </div>
                <h2 class="card-pf-title text-center">
                  {{
                    onUpgrade
                      ? $t("payment.upgrade_proceed")
                      : $t("payment.renew_proceed")
                  }}
                </h2>
                <div class="card-pf-items text-center">
                  <div class="card-pf-item details-pay-item">
                    <span class="card-pf-item-text">
                      <strong>{{ $t("payment.plan") }}</strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <div class="dropdown">
                      <button
                        class="btn btn-default dropdown-toggle"
                        type="button"
                        id="dropdownMenu1"
                        data-toggle="dropdown"
                      >
                        {{ currentPlan.name }}
                        <span class="caret"></span>
                      </button>
                      <ul
                        class="dropdown-menu"
                        role="menu"
                        aria-labelledby="dropdownMenu1"
                      >
                        <li
                          v-for="p in plans"
                          v-if="
                            p.code !== 'trial' &&
                            p.code !== 'trial-ns8' &&
                            p.code !== 'trial-nsec'
                          "
                          v-bind:key="p.code"
                          role="presentation"
                          :class="[
                            p.code == currentPlan.code ? 'selected' : '',
                            p.code != obj.subscription.subscription_plan.code &&
                            (p.base_price || p.price || p.full_price) <
                              obj.subscription.subscription_plan.base_price
                              ? 'disabled'
                              : '',
                          ]"
                        >
                          <a
                            @click="
                              p.code !=
                                obj.subscription.subscription_plan.code &&
                              (p.full_price || p.price || p.base_price) <
                                obj.subscription.subscription_plan.base_price
                                ? null
                                : changePlan(p, false)
                            "
                            role="menuitem"
                            tabindex="-1"
                            href="#"
                          >
                            <img
                              :src="getImage(p.base_code)"
                              class="plan-icon-mini"
                            />
                            {{ p.name }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  v-show="
                    currentPlan.code != 'crostino' &&
                    currentPlan.code != 'pizza' &&
                    currentPlan.code != 'lasagna' &&
                    currentPlan.code != 'fiorentina'
                  "
                  class="card-pf-items text-center"
                >
                  <div
                    v-if="
                      services[extractProduct(currentPlan.code)] &&
                      services[extractProduct(currentPlan.code)].length > 0
                    "
                    class="card-pf-item details-pay-item"
                  >
                    <span class="card-pf-item-text">
                      <strong>{{ $t("payment.services") }}</strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <ul class="services-list">
                      <li
                        v-for="s in services[extractProduct(currentPlan.code)]"
                        v-bind:key="s.code"
                      >
                        <input
                          type="checkbox"
                          :name="s.code"
                          :value="s.code"
                          v-model="selectedServices"
                          @change="changePlan(currentPlan, true)"
                          :disabled="currentServices.indexOf(s.code) != -1"
                        />
                        <label :for="s.code"
                          >{{ s.name }} (+{{ s.price }}€ / year)</label
                        ><br />
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="card-pf-items text-center">
                  <div class="card-pf-item details-pay-item">
                    <span class="card-pf-item-text">
                      <strong>{{ $t("payment.details") }}</strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <div
                      v-if="!onUpgradePriceCalc"
                      class="details-markdown text-left"
                      v-html="markdownDescription"
                    ></div>
                    <div
                      v-if="onUpgradePriceCalc"
                      class="spinner spinner-sm"
                    ></div>
                  </div>
                </div>
                <div class="card-pf-items text-center">
                  <div class="card-pf-item details-pay-item">
                    <span class="card-pf-item-text">
                      <strong>{{ $t("payment.price") }} </strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <span v-if="!onUpgradePriceCalc" class="card-pf-item-text">
                      <strong
                        >{{
                          currentPlan.full_price > 0
                            ? currentPlan.full_price
                            : 0
                        }}€ / year</strong
                      >
                    </span>
                    <div
                      v-if="onUpgradePriceCalc"
                      class="spinner spinner-sm"
                    ></div>
                  </div>
                </div>

                <div
                  v-if="
                    onUpgrade &&
                    currentPlan.price != currentPlan.full_price &&
                    discounts.annualDiscount > 0
                  "
                  class="card-pf-items text-center"
                >
                  <div class="card-pf-item details-pay-item">
                    <span class="card-pf-item-text">
                      <strong>{{
                        $t("payment.previous_license_discount")
                      }}</strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <span v-if="!onUpgradePriceCalc" class="card-pf-item-text">
                      <strong>{{ discounts.annualDiscount }}€</strong>
                    </span>
                    <div
                      v-if="onUpgradePriceCalc"
                      class="spinner spinner-sm"
                    ></div>
                  </div>
                </div>

                <div
                  v-if="discounts.volumeDiscount != 0"
                  class="card-pf-items text-center"
                >
                  <div class="card-pf-item details-pay-item">
                    <span class="card-pf-item-text">
                      <strong>{{ $t("payment.volume_discount") }}</strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <span v-if="!onUpgradePriceCalc" class="card-pf-item-text">
                      <strong>{{ discounts.volumeDiscount }}%</strong>
                      <span>
                        (<strong>{{ discounts.count }}</strong>
                        {{ $t("payment.active_licenses") }})</span
                      >
                    </span>
                    <div
                      v-if="onUpgradePriceCalc"
                      class="spinner spinner-sm"
                    ></div>
                  </div>
                </div>

                <div class="card-pf-items text-center">
                  <div class="card-pf-item details-pay-item">
                    <span class="card-pf-item-text">
                      <strong>{{ $t("payment.period") }}</strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <span
                      v-if="!onUpgrade && !onUpgradePriceCalc"
                      class="card-pf-item-text"
                    >
                      <span v-if="isExpired(obj.subscription.valid_until)">
                        {{ new Date().toISOString() | formatDate(false) }} -
                        {{
                          calculateSubscription(
                            new Date().toISOString(),
                            obj.subscription.subscription_plan
                          ) | formatDate(false)
                        }}
                      </span>
                      <span v-else>
                        {{ obj.subscription.valid_until | formatDate(false) }} -
                        {{
                          calculateSubscription(
                            obj.subscription.valid_until,
                            obj.subscription.subscription_plan
                          ) | formatDate(false)
                        }}
                      </span>
                    </span>
                    <span
                      v-if="onUpgrade && !onUpgradePriceCalc"
                      class="card-pf-item-text"
                      >{{ new Date().toISOString() | formatDate(false) }} -
                      {{
                        calculateSubscription(
                          new Date().toISOString(),
                          currentPlan
                        ) | formatDate(false)
                      }}</span
                    >
                    <div
                      v-if="onUpgradePriceCalc"
                      class="spinner spinner-sm"
                    ></div>
                  </div>
                </div>

                <div class="card-pf-items text-center">
                  <div class="card-pf-item details-pay-item">
                    <span class="card-pf-item-text">
                      <strong>{{ $t("payment.final_price") }}</strong>
                    </span>
                  </div>
                  <div class="card-pf-item details-pay-item">
                    <span v-if="!onUpgradePriceCalc" class="card-pf-item-text">
                      <strong v-if="discounts.annualDiscount > 0"
                        >{{ Math.round(currentPlan.price * 100) / 100 }}€ (then
                        {{ currentPlan.full_price }}€ / year)</strong
                      >
                      <strong v-if="discounts.annualDiscount == 0"
                        >{{ Math.round(currentPlan.price * 100) / 100 }}€ / year</strong
                      >
                      <span>+ {{ $t("payment.taxes") }}</span>
                    </span>
                    <div
                      v-if="onUpgradePriceCalc"
                      class="spinner spinner-sm"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="modal-footer text-center">
            <div v-if="payment.onProgress" class="spinner"></div>
            <div
              v-if="payment.done && !errors.state && !payment.onProgress"
              class="alert alert-success alert-dismissable"
            >
              <span class="pficon pficon-ok"></span>
              <strong>{{ $t("payment.confirmed") }}</strong
              >. {{ $t("payment.payment_id_ref") }}
              <pre
                class="filters-container"
              ><strong>{{payment.details.paymentID}}</strong></pre>
            </div>
            <button
              v-if="payment.done && !errors.state && !payment.onProgress"
              type="button"
              class="btn btn-primary done-payment-button"
              @click="hideRenewModal()"
            >
              {{ $t("servers.done") }}
            </button>
            <div
              v-if="
                !payment.done &&
                !errors.state &&
                !payment.onProgress &&
                currentPlan.price > 0
              "
              class="card-pf-item details-pay-item"
            >
              <span class="card-pf-item-text">
                <strong>{{ $t("payment.pay_with") }}</strong>
              </span>
            </div>
            <div
              v-show="currentPlan.price == 0"
              class="alert alert-warning alert-dismissable"
            >
              <span class="pficon pficon-warning-triangle-o"></span>
              <strong>{{ $t("payment.invalid_subscription") }}</strong>
              {{ $t("payment.invalid_subscription_text") }}
            </div>
            <div
              v-show="
                !payment.done &&
                !errors.state &&
                !payment.onProgress &&
                currentPlan.price > 0
              "
              :id="'paypal-button-container-' + obj.id"
            ></div>
            <div
              v-if="payment.done && errors.state && !payment.onProgress"
              class="alert alert-danger alert-dismissable"
            >
              <span class="pficon pficon-error-circle-o"></span>
              <strong>{{ $t("payment.payment_error") }}</strong
              >. {{ errors.message || $t("payment.payment_error_details") }}
              <p>{{ $t("payment.payment_id_ref") }}</p>
              <pre
                class="filters-container"
              ><strong>{{payment.details.paymentID}}</strong></pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
import StorageService from "./../../services/storage";

import paypal from "paypal-checkout";
import { setTimeout } from "timers";
import marked from "marked";

export default {
  name: "RenewButton",
  props: ["obj", "update"],
  mixins: [StorageService],
  mounted() {
    var context = this;
    paypal.Button.render(
      {
        env: CONFIG.PAYPAL_PRODUCTION ? "production" : "sandbox",
        style: {
          layout: "vertical", // horizontal | vertical
          size: "medium", // medium | large | responsive
          shape: "rect", // pill | rect
          color: "gold", // gold | blue | silver | black
        },
        funding: {
          allowed: [paypal.FUNDING.CARD],
          disallowed: [paypal.FUNDING.CREDIT],
        },
        client: {
          sandbox: CONFIG.PAYPAL_SANDBOX,
          production: CONFIG.PAYPAL_PRODUCTION,
        },
        payment: function (data, actions) {
          return actions.payment.create({
            payment: {
              transactions: [
                {
                  amount: {
                    total:
                      Math.round(
                        (context.currentPlan.price +
                          (context.currentPlan.price *
                            context.billingInfo.tax) /
                            100) *
                          100
                      ) / 100,
                    currency: "EUR",
                    details: {
                      subtotal:
                        Math.round(context.currentPlan.price * 100) / 100,
                      tax:
                        Math.round(
                          ((context.currentPlan.price *
                            context.billingInfo.tax) /
                            100) *
                            100
                        ) / 100,
                    },
                  },
                  item_list: {
                    items: [
                      {
                        name: context.currentPlan.code,
                        description: context.currentPlan.name,
                        sku: context.obj.uuid,
                        price: Math.round(context.currentPlan.price * 100) / 100,
                        currency: "EUR",
                        quantity: "1",
                      },
                    ],
                  },
                },
              ],
            },
            experience: {
              input_fields: {
                no_shipping: 1,
              },
            },
          });
        },

        onAuthorize: function (data, actions) {
          return actions.payment.execute().then(function () {
            context.payment.onProgress = true;
            if (context.onUpgrade) {
              context.upgradeCheck(data);
            } else {
              context.renewCheck(data);
            }
          });
        },
      },
      "#paypal-button-container-" + this.obj.id
    );
  },
  data() {
    // get plans
    this.plansList();

    // read upgrade ref and show modal
    if (this.get("upgrade_ref", false)) {
      var context = this;
      setTimeout(function () {
        context.showRenewModal(context.get("upgrade_ref", false));
        context.delete("upgrade_ref");
      }, 0);
    }

    return {
      payment: {
        done: false,
        details: {},
        onProgress: false,
      },
      errors: {
        message: "",
        state: false,
      },
      plans: [],
      services: {
        ns8: _.orderBy(
          [
            // { name: this.$i18n.t("servers.ldap_mattermost"), code: "ldap_mattermost", price: 120.0 },
            // { name: this.$i18n.t("servers.nethvoice"), code: "nethvoice", price: 120.0 },
          ],
          "name",
          "asc"
        ),
        nsec: _.orderBy(
          [
            {
              name: this.$i18n.t("servers.hotspot"),
              code: "hotspot",
              price: 120.0,
            },
            {
              name: this.$i18n.t("servers.threat_shield"),
              code: "threat_shield",
              price: 48.0,
            },
            // { name: this.$i18n.t("servers.flashstart_lite"), code: "flashstart_lite", price: 18.0 },
          ],
          "name",
          "asc"
        ),
      },
      selectedServices: this.extractServices(
        this.obj.subscription.subscription_plan.code
      ),
      selectedPlan: {},
      markdownDescription: "",
      currentPlan: this.obj.subscription.subscription_plan,
      currentServices: this.extractServices(
        this.obj.subscription.subscription_plan.code
      ),
      billingInfo: {},
      discounts: {
        volumeDiscount: 0,
        count: 0,
        annualDiscount: 0,
      },
      onUpgradePriceCalc: false,
      onUpgrade: false,
      upgradeStartDate: new Date().toISOString(),
      upgradeEndDate: new Date().toISOString(),
    };
  },
  methods: {
    getImage(s) {
      if (s == "crostino") {
        return require("./../../assets/crostino.svg");
      }
      if (s == "lasagna") {
        return require("./../../assets/lasagna.svg");
      }
      if (s == "fiorentina") {
        return require("./../../assets/fiorentina.svg");
      }
      if (s == "pizza") {
        return require("./../../assets/pizza.svg");
      }
      if (s == "personal-ns8") {
        return require("./../../assets/circle-personal-ns8.svg");
      }
      if (s == "personal-nsec") {
        return require("./../../assets/circle-personal-nsec.svg");
      }
      if (s == "business-ns8") {
        return require("./../../assets/circle-business-ns8.svg");
      }
      if (s == "business-nsec") {
        return require("./../../assets/circle-business-nsec.svg");
      }
      if (s == "trial-ns8") {
        return require("./../../assets/trial-ns8.svg");
      }
      if (s == "trial-nsec") {
        return require("./../../assets/trial-nsec.svg");
      }
      return require("./../../assets/trial.svg");
    },
    extractProduct(license) {
      var product = license.split("-")[1];
      return product ? product.split("+")[0] : "";
    },
    extractServices(plan) {
      var code = plan.split("+")[1];
      return code ? code.split(",").sort() : [];
    },
    isExpired(date) {
      return new Date().toISOString() > date;
    },
    getButtonText(code) {
      const isTrial = code.includes("trial-");
      const isPersonal = code.includes("personal-");
      const isBusiness = code.includes("business-");
      
      // Trial (active or expired) → "Upgrade"
      if (isTrial) {
        return this.$t("payment.upgrade_button");
      }
      
      // Personal active or expired → "Upgrade or Renew"
      if (isPersonal) {
        return this.$t("payment.upgrade_button") + " " + this.$t("or") + " " + this.$t("payment.renew_button");
      }
      
      // Business active or expired → "Renew"
      if (isBusiness) {
        return this.$t("payment.renew_button");
      }
      
      // Default
      return this.$t("payment.upgrade_button");
    },
    showRenewModal(id) {
      this.$http
        .get(
          this.$root.$options.api_scheme +
            this.$root.$options.api_host +
            "/api/ui/billings",
          {
            headers: {
              Authorization: "Bearer " + this.get("access_token", false) || "",
            },
          }
        )
        .then(
          function (success) {
            this.billingInfo = success.body;
            this.payment.done = false;
            this.payment.onProgress = false;
            this.payment.details = {};
            this.errors.message = "";
            this.errors.state = false;
            this.currentPlan =
              this.obj.subscription.subscription_plan.code != "trial" &&
              this.obj.subscription.subscription_plan.code != "trial-ns8" &&
              this.obj.subscription.subscription_plan.code != "trial-nsec"
                ? this.obj.subscription.subscription_plan
                : this.plans[1];
            if (
              this.obj.subscription.subscription_plan.code == "trial" ||
              this.obj.subscription.subscription_plan.code == "trial-ns8" ||
              this.obj.subscription.subscription_plan.code == "trial-nsec"
            ) {
              this.currentPlan.full_price = this.plans[1].price;
            } else {
              this.currentPlan.full_price = this.currentPlan.price;
            }
            this.markdownDescription = marked(this.currentPlan.description, {
              sanitize: true,
            });
            this.onUpgradePriceCalc = false;
            
            // Determine if it's upgrade or renew based on license status and type
            const currentCode = this.obj.subscription.subscription_plan.code;
            const isBusiness = currentCode.includes("business-");
            const isPersonal = currentCode.includes("personal-");
            
            // onUpgrade logic:
            // 1. Trial (active or expired) → upgrade (onUpgrade = true)
            // 2. Personal active → renew (onUpgrade = false) or upgrade (onUpgrade = true)
            // 3. Personal expired → renew (onUpgrade = false) if same plan, upgrade (onUpgrade = true) if different plan
            // 4. Business active → can only renew (onUpgrade = false)
            // 5. Business expired → renew (onUpgrade = false)
            
            // If it's business (active or expired), it's always a renew
            if (isBusiness) {
              this.onUpgrade = false;
            }
            // If it's personal (active or expired), it's a renew by default (can be changed to upgrade via dropdown)
            else if (isPersonal) {
              this.onUpgrade = false;
            }
            // All other cases are upgrade (trial)
            else {
              this.onUpgrade = true;
            }

            // check volume discounts
            this.$http
              .get(
                this.$root.$options.api_scheme +
                  this.$root.$options.api_host +
                  "/api/ui/plans/volume_discount",
                {
                  headers: {
                    Authorization:
                      "Bearer " + this.get("access_token", false) || "",
                  },
                }
              )
              .then(
                function (success) {
                  this.currentPlan.price =
                    this.currentPlan.price -
                    (this.currentPlan.full_price * success.body.discount) / 100;
                  this.discounts.volumeDiscount = success.body.discount;
                  this.discounts.count = success.body.count;
                  $("#paymentModalRenew-" + id).modal("toggle");
                },
                function (error) {
                  console.error(error);
                }
              );
          },
          function (error) {
            this.$parent.$parent.action = "updateBilling";
            this.set("upgrade_ref", id);
            this.$router.push({
              path: "/profile",
            });
            console.error(error);
          }
        );
    },
    hideRenewModal() {
      this.update();
      $("#paymentModalRenew-" + this.obj.id).modal("hide");
    },
    plansList() {
      this.$http
        .get(
          this.$root.$options.api_scheme +
            this.$root.$options.api_host +
            "/api/ui/plans",
          {
            headers: {
              Authorization: "Bearer " + this.get("access_token", false) || "",
            },
          }
        )
        .then(
          function (success) {
            this.plans = _.orderBy(success.body, "price", "asc");
            this.plans = this.plans.filter(
              (plan) =>
                plan.code != "trial" &&
                plan.code != "trial-ns8" &&
                plan.code != "trial-nsec" &&
                plan.code != "crostino" &&
                plan.code != "lasagna" &&
                plan.code != "pizza" &&
                plan.code != "fiorentina"
            );

            // check current subscription
            if (this.obj.subscription.subscription_plan.code.includes("ns8")) {
              this.plans = this.plans.filter(
                (plan) =>
                  plan.code != "trial-nsec" &&
                  plan.code != "personal-nsec" &&
                  plan.code != "business-nsec"
              );
            }
            if (this.obj.subscription.subscription_plan.code.includes("nsec")) {
              this.plans = this.plans.filter(
                (plan) =>
                  plan.code != "trial-ns8" &&
                  plan.code != "personal-ns8" &&
                  plan.code != "business-ns8"
              );
            }
          },
          function (error) {
            console.error(error);
          }
        );
    },
    changePlan(plan, withServices) {
      if (this.currentServices.length > 0 && !withServices) {
        this.selectedServices = this.currentServices;
        withServices = true;
      }

      var newCode = plan.base_code;
      if (withServices && this.selectedServices.length > 0) {
        newCode = "!" + newCode + "+" + this.selectedServices.sort().join(",");
      } else {
        this.selectedServices = [];
      }

      if (
        newCode !== this.obj.subscription.subscription_plan.code ||
        withServices
      ) {
        // handle upgrade
        var context = this;
        this.calculateUpgradePrice(newCode, function (data) {
          context.onUpgrade = true;
          context.currentPlan = JSON.parse(JSON.stringify(plan));
          context.currentPlan.id = data.id;
          context.currentPlan.price = data.price;
          context.currentPlan.full_price = data.full_price;
          context.discounts.annualDiscount =
            Math.round(data.discount * 100) / 100;
          context.markdownDescription = marked(plan.description, {
            sanitize: true,
          });

          // check volume discounts
          context.$http
            .get(
              context.$root.$options.api_scheme +
                context.$root.$options.api_host +
                "/api/ui/plans/volume_discount",
              {
                headers: {
                  Authorization:
                    "Bearer " + context.get("access_token", false) || "",
                },
              }
            )
            .then(
              function (success) {
                context.currentPlan.price =
                  context.currentPlan.price -
                  (context.currentPlan.full_price * success.body.discount) /
                    100;
                context.discounts.volumeDiscount = success.body.discount;
                context.discounts.count = success.body.count;
                context.currentPlan.code = newCode;
              },
              function (error) {
                console.error(error);
              }
            );
        });
      } else {
        this.onUpgrade = false;
        this.currentPlan = JSON.parse(JSON.stringify(plan));
        this.currentPlan.full_price = plan.price;
        this.currentPlan.price = plan.price;
        this.markdownDescription = marked(plan.description, { sanitize: true });

        // check volume discounts
        this.$http
          .get(
            this.$root.$options.api_scheme +
              this.$root.$options.api_host +
              "/api/ui/plans/volume_discount",
            {
              headers: {
                Authorization:
                  "Bearer " + this.get("access_token", false) || "",
              },
            }
          )
          .then(
            function (success) {
              this.currentPlan.price =
                this.currentPlan.price -
                (this.currentPlan.full_price * success.body.discount) / 100;
              this.discounts.volumeDiscount = success.body.discount;
              this.discounts.count = success.body.count;
              this.currentPlan.code = newCode;
            },
            function (error) {
              console.error(error);
            }
          );
      }
    },
    calculateUpgradePrice(plan, callback) {
      this.onUpgradePriceCalc = true;
      this.$http
        .get(
          this.$root.$options.api_scheme +
            this.$root.$options.api_host +
            "/api/ui/systems/" +
            this.obj.id +
            "/upgrade_price?plan=" +
            encodeURIComponent(plan),
          {
            headers: {
              Authorization: "Bearer " + this.get("access_token", false) || "",
            },
          }
        )
        .then(
          function (success) {
            this.onUpgradePriceCalc = false;
            callback(success.body);
          },
          function (error) {
            console.error(error);
            this.onUpgradePriceCalc = false;
          }
        );
    },
    calculateSubscription(date, subscription) {
      var moment = require("moment/moment.js");
      return moment(date, "YYYY-MM-DDTHH:mm:ss").add(
        subscription.period,
        "days"
      );
    },
    renewCheck(payment) {
      this.$http
        .post(
          this.$root.$options.api_scheme +
            this.$root.$options.api_host +
            "/api/ui/systems/" +
            this.obj.id +
            "/renewal",
          {
            payment_id: payment.paymentID,
          },
          {
            headers: {
              Authorization: "Bearer " + this.get("access_token", false) || "",
            },
          }
        )
        .then(
          function (success) {
            this.payment.onProgress = false;
            this.payment.details = payment;
            this.payment.done = true;
          },
          function (error) {
            console.error(error);
            this.payment.onProgress = false;
            this.payment.details = payment;
            this.payment.done = true;
            this.errors.state = true;
            this.errors.message = error.body.message;
          }
        );
    },
    upgradeCheck(payment) {
      this.$http
        .post(
          this.$root.$options.api_scheme +
            this.$root.$options.api_host +
            "/api/ui/systems/" +
            this.obj.id +
            "/upgrade",
          {
            payment_id: payment.paymentID,
            subscription_plan_id: this.currentPlan.id,
          },
          {
            headers: {
              Authorization: "Bearer " + this.get("access_token", false) || "",
            },
          }
        )
        .then(
          function (success) {
            this.payment.onProgress = false;
            this.payment.details = payment;
            this.payment.done = true;
          },
          function (error) {
            console.error(error);
            this.payment.onProgress = false;
            this.payment.details = payment;
            this.payment.done = true;
            this.errors.state = true;
            this.errors.message = error.body.message;
          }
        );
    },
  },
};
</script>
<style>
.services-list {
  list-style: none;
  padding-left: 5px;
  text-align: left;
  margin-bottom: 0px;
}

.plan-icon-mini {
  width: 30px;
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/directives/RenewButton.vue